import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import Panel from '../../../controls/Panel';
import Typography from '@material-ui/core/Typography';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@material-ui/core';
import MaterialTable, { MTableBodyRow } from 'material-table';
import Hidden from '@material-ui/core/Hidden';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Button from '../../../controls/Button';
import AddIcon from '@material-ui/icons/Add';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';

const styles = (theme) => ({
    table: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
    },
    center: {
        textAlign: 'center',
    },
    container: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    title: {
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
    },
    addButton: {
        marginLeft: theme.spacing(1),
        borderColor: theme.palette.divider,
        padding: theme.spacing(1),
    },
    tableRow: {
        '&:hover $itemDeleteAction': {
            visibility: 'visible',
        },
    },
    itemDeleteAction: {
        visibility: 'hidden',
    },
});

class FormFindersPanel extends React.Component {
    state = {
        deleteDialog: false,
        formFinder: null,
    };

    startNew = () => {
        this.props.history.push('/formFinder/new');
    };

    selectFormFinder = (form) => {
        this.props.history.push(`/formFinder/${form.id}`);
    };

    handlePopup = (event, formFinder) => {
        event.stopPropagation();
        this.setState({
            deleteDialog: true,
            formFinder: formFinder,
        });
    };

    handleDelete = () => {
        this.props.onDelete(this.state.formFinder);
        this.setState({
            deleteDialog: false,
        });
    };

    handleCancel = () => {
        this.setState({
            deleteDialog: false,
        });
    };

    render() {
        const deleteDialog = (
            <Dialog open={this.state.deleteDialog}>
                <DialogTitle>Wait!</DialogTitle>
                <DialogContent>
                    <DialogContentText id="deleteForm">
                        Are you sure you want to permanently delete this form finder?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleCancel} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={this.handleDelete} variant="contained" color="primary">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        );

        return (
            <React.Fragment>
                <Panel>
                    <div className={this.props.classes.container}>
                        <div className={this.props.classes.title}>
                            <Typography variant="h6">Your Form Finders</Typography>
                        </div>

                        <div className={this.props.classes.addButton}>
                            <Tooltip title="Create New Form Finder">
                                <Button variant="contained" color="green" onClick={this.startNew}>
                                    <AddIcon />
                                </Button>
                            </Tooltip>
                        </div>
                    </div>

                    <Hidden xsDown>
                        <MaterialTable
                            options={{
                                toolbar: false,
                                paging: false,
                                draggable: false,
                            }}
                            components={{
                                Container: ({ children }) => <div className={this.props.classes.table}>{children}</div>,
                                Row: (props) => <MTableBodyRow className={this.props.classes.tableRow} {...props} />,
                            }}
                            localization={{
                                body: {
                                    emptyDataSourceMessage: 'No Form Finders To Display',
                                },
                            }}
                            columns={[
                                { title: 'Form Finder ID', field: 'id' },
                                { title: 'Form Finder Name', field: 'name' },
                                {
                                    render: (rowData) => (
                                        <Tooltip className={this.props.classes.itemDeleteAction} title="Delete">
                                            <IconButton
                                                aria-label="delete"
                                                onClick={(event) => this.handlePopup(event, rowData)}
                                            >
                                                <DeleteIcon color="action" />
                                            </IconButton>
                                        </Tooltip>
                                    ),
                                    cellStyle: {
                                        textAlign: 'right',
                                        padding: 0,
                                    },
                                    headerStyle: {
                                        visibility: 'hidden',
                                    },
                                    width: '48px',
                                    sorting: false,
                                },
                            ]}
                            data={this.props.forms}
                            onRowClick={(evt, row) => this.selectFormFinder(row)}
                        />
                    </Hidden>
                    <Hidden smUp>
                        {this.props.forms && (
                            <List>
                                {this.props.forms.map((form) => (
                                    <ListItem key={form.id} button onClick={() => this.selectFormFinder(form)}>
                                        <ListItemText primary={form.name} secondary={form.id} />
                                        <ListItemSecondaryAction>
                                            <Tooltip title="Delete">
                                                <IconButton
                                                    aria-label="delete"
                                                    onClick={(event) => this.handlePopup(event, form)}
                                                >
                                                    <DeleteIcon color="action" />
                                                </IconButton>
                                            </Tooltip>
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                ))}
                            </List>
                        )}
                    </Hidden>
                </Panel>
                {deleteDialog}
            </React.Fragment>
        );
    }
}

export default withRouter(withStyles(styles)(FormFindersPanel));
